import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import AMPPage from '../AMPPage';
import AMPPageHeader from '../AMPPageHeader';
import AMPPageSection from '../AMPPageSection';
import AMPPodcastReadySection from '../AMPPodcastReadySection';
import Img from '../Img';
import OutboundLink from '../OutboundLink';
import styles from './styles.sass';

const METADATA = {
  TITLE: 'About',
};

const IMG_PREFIX = 'https://d12xoj7p9moygp.cloudfront.net/images/';

const EMPLOYEE_DATA = [
  {
    name: 'Dave Altarescu',
    role: 'Marketing',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-dave.jpeg',
    twitterUrl: 'https://twitter.com/davebalt',
    description:
      'Studied production & engineering at Berklee College of Music. Worked at Warner and Spotify. Thinking about making a welding podcast.',
  },
  {
    name: 'Jessica Angeles',
    role: 'Creator Relations',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-jess.jpg',
    description:
      'Amateur cook, rock climber and high-key pasta lover. Willing to empty her bank account for a good meal at any time. Karaoke is her favorite sport.',
  },
  {
    name: 'Chris Bosco',
    role: 'Web',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-chris-2.JPG',
    twitterUrl: 'https://twitter.com/cbsides',
    description:
      'Prefers everything (entertainment, meditation, news) in audio form. Can defeat you easily in a friendly pun standoff.',
  },
  {
    name: 'Tyler Brann',
    role: 'People',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-tyler.jpg',
    twitterUrl: '',
    description:
      'Dad, sports fanatic (go Sox), and pretend singer songwriter. Makes friends with everyone. Can be peer pressured into karaoke at any time.',
  },
  {
    name: 'Sarah Capone',
    role: 'Product',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-sarah.png',
    withRetina: true,
    twitterUrl: '',
    description:
      'Lifelong dancer (ballet and jazz). Always listening to music. Reigning champ of Susho, the official game of Anchor HQ.',
  },
  {
    name: 'Vincent Carbellano',
    role: 'Support',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-vincent.png',
    description:
      'Thrives on helping. More dialed in to "beard culture" than he\'d care to admit. Will always think superheroes, and dogs (and superhero dogs?) are rad.',
  },
  {
    name: 'Cass Chin',
    role: 'Web',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-cass.jpg',
    description: (
      <div>
        <p>A haiku:</p>
        <p>Programs for the web</p>
        <p>Couch chillin' with wife and dog</p>
        <p>Bikin' and 'buchin'</p>
      </div>
    ),
  },
  {
    name: 'Jeff Crocker',
    role: 'Backend',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-jeffc.png',
    withRetina: true,
    twitterUrl: '',
    description:
      'Got into programming because it was the closest he could get to learning magic. Is happy anywhere, as long as he can listen to podcasts.',
  },
  {
    name: 'Lisa Fierstein',
    role: 'Social',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-lisa.jpg',
    description:
      "Once was in a Ska band. Can't hear as well when she's not wearing her glasses. Loves her grandmothers and is secretly 87 years of age.",
  },
  {
    name: 'Joe Gesualdo',
    role: 'Web',
    imageUrl: 'https://d12xoj7p9moygp.cloudfront.net/images/team/about-joe.jpg',
    twitterUrl: '',
    description:
      "Hacker. Adventure lover. Pet whisperer. Loves old-time radio shows from the '40s and '50s more than the average millennial.",
  },
  {
    name: 'Kyle Gordon',
    role: 'Android',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-kyle.jpg',
    twitterUrl: '',
    description:
      'Android enthusiast. Golfer. Michigan fan (Go Blue). Once said "I will never live in NYC"; now a proud New Yorker.',
  },
  {
    name: 'Taquaisha Hawkins',
    role: 'Ad Operations',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-taquaisha.jpg',
    description:
      'Hip-hop and rap guru (probably was a rapper in her past life). Game of Thrones enthusiast, and convinced The Office is the greatest show of all time.',
  },
  {
    name: 'Emmi Hintz',
    role: 'Design',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-emmi.jpg',
    twitterUrl: 'https://twitter.com/digitalGoGetta',
    description:
      'Loves iOS and Android equally. Can only design while listening to Petit Biscuit. Does a mean goat voice impression, whatever that means.',
  },
  {
    name: 'John Lagomarsino',
    role: 'Production',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-john.png',
    withRetina: true,
    twitterUrl: '',
    description:
      'Previously made audio and video at The Verge, Mic, and The Outline. Listens carefully, plays piano poorly.',
  },
  {
    name: 'Michael Mignano',
    role: 'Co-Founder and CEO',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-mike-2.png',
    twitterUrl: 'https://twitter.com/mignano',
    description:
      'Dad. Designer. Drummer. Has only worked (and will only work) for companies that begin with the letter ‘A’.',
  },
  {
    name: 'Ana Olson',
    role: 'Podcaster Success',
    imageUrl: 'https://d12xoj7p9moygp.cloudfront.net/images/team/about-ana.jpg',
    description:
      'Happiest with a pen or passport in hand. Picks great citrus. Loves to cozy up with a good medical podcast or some disaster fiction.',
  },
  {
    name: 'Bryan Oltman',
    role: 'iOS',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-bryan-o.jpg',
    twitterUrl: '',
    description:
      'Guitar player, biker, programmer. On a good day, fixes more bugs than he creates.',
  },
  {
    name: 'Andrew Parrish',
    role: 'Backend',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-andrew.jpg',
    description:
      'Programmer, skier, and eternally suffering Atlanta sports fan. Can usually be found listening to a podcast while thinking about a different podcast.',
  },
  {
    name: 'Laura Pezzini',
    role: 'Comms',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-laura-2.jpg',
    description:
      'Comes from a long line of artichoke farmers. Can usually be found at a concert; listens to too many pop music theory podcasts.',
  },
  {
    name: 'Patrick Pierson',
    role: 'iOS',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-patrick.jpg',
    twitterUrl: 'https://twitter.com/ppiers0n',
    description:
      'Always listening to metal. Passionate about video games and beer. Believes in outdoor cats.',
  },
  {
    name: 'Grant Polmanteer',
    role: 'Intern',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-grant.png',
    withRetina: true,
    twitterUrl: '',
    description:
      'You might have heard rumors about how nice Grant is. The rumors are true. He can also play the saxophone and would like to pet your dog, please.',
  },
  {
    name: 'Maya Prohovnik',
    role: 'Product',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-maya.png',
    twitterUrl: 'https://twitter.com/mayafish',
    description:
      'Obsessed with making you happy. Has her own Stephen King podcast where she spins wild conspiracy theories.',
  },
  {
    name: 'Angela Reynoso',
    role: 'Design',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-angela.jpg',
    twitterUrl: '',
    description:
      'Adventurer, animal lover, salsa dancer and salsa eater. Loves creating delightful apps and wants to hear your idea for your next podcast.',
  },
  {
    name: 'Ryan Rosa',
    role: 'Operations',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-ryan.png',
    withRetina: true,
    twitterUrl: '',
    description:
      'All about making Anchor the best place in the world to work. Hosted a fake radio station as a kid; now spends her free time preparing for the apocalypse.',
  },
  {
    name: 'Anna Sian',
    role: 'Marketing',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-anna.jpg',
    twitterUrl: '',
    description:
      'Hip hop and R&B aficionado, but played in a band that critics called “post-punk electro-soul.” Loves photography and Japanese food, esp uni.',
  },
  {
    name: 'Alec Tarantino',
    role: 'Business Operations',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-alec.jpg',
    twitterUrl: '',
    description:
      'Lover of food (cooking & eating), soccer (playing & watching) and music (making & listening). Settler of Catan. Undercover freestyle rapper.',
  },
  {
    name: 'Sam Ward',
    role: 'Engineering',
    imageUrl: 'https://d12xoj7p9moygp.cloudfront.net/images/team/about-sam.jpg',
    description:
      'Coworker hydrator. Cat friend. Sometimes musician. People gatherer. Incomplete sentence writer. Working on a podcast about chapstick.',
  },
  {
    name: 'Armand Wilson',
    role: 'Marketing',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-armand.jpg',
    description:
      "Sneakerhead, washed up ice cream man, podcast papi. Currently trying to get your favorite rapper's favorite rapper to start a podcast.",
  },
  {
    name: 'Nir Zicherman',
    role: 'Co-Founder and CTO',
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/team/about-nir-2.png',
    twitterUrl: 'https://twitter.com/nirzicherman',
    description:
      'Loves logic more than anything (except coffee and his family). Lifelong musician. Lives by the motto “Anything is possible.”',
  },
];

const AMPAboutPage = props => {
  const isAmp = props.context && props.context.isAmpRoute;
  return (
    <AMPPage isAmpRoute={isAmp}>
      <AMPPageHeader
        title="About Anchor"
        subtitle="Anchor is the easiest way to make a podcast, ever."
      />
      <AMPPageSection id="Who-We-Are" color="gray">
        <span className={styles.description}>
          Our mission is to democratize audio. We believe everyone should be
          able to have their voice heard, regardless of background or experience
          level. If you’ve ever tried to start a podcast, you know all the
          logistical barriers that can stand in your way. At Anchor, we aim to
          remove all of these barriers. Our goal is to make podcasting easy and
          fun, without sacrificing the quality every podcaster deserves.
        </span>
      </AMPPageSection>
      <AMPPageSection id="how">
        <Row className={`${styles.infoRow}`}>
          <Col xs={12} sm={8}>
            <h2>How we do it</h2>
            <h3>Creators first.</h3>
            <p>
              Everything we do, we do it for podcasters. Whether you’re a
              seasoned pro or just starting your podcasting journey, Anchor was
              built to solve the pain points around podcasting, while remaining
              powerful enough to make your wildest podcasting dreams come true.
            </p>
            <h3>Tools that are really, really easy to use.</h3>
            <p>
              We’ve reimagined podcasting from the ground up. Every feature in
              Anchor is designed to be so straightforward that anyone (even
              people with zero podcasting experience) can pick it up and start
              using it right away.
            </p>
            <h3>Powerful technology that solves real problems.</h3>
            <p>
              We build intelligent tools that minimize the grunt work, and help
              you navigate podcasting best practices so you can focus on making
              something amazing. Whether it’s recording, editing, or getting
              listeners, we want you to feel like nothing is standing in the way
              of you telling your story.
            </p>
          </Col>
          <Col xs={12} sm={4}>
            <Img
              isAmp={isAmp}
              alt="How we do it"
              src={`${IMG_PREFIX}about-how.png`}
              layout="fixed"
              withRetina
              width={230}
              height={446}
            />
          </Col>
        </Row>
      </AMPPageSection>
      <AMPPageSection color="blue" id="history" className={styles.aboutStory}>
        <div className={styles.polaroids}>
          <Img
            isAmp={isAmp}
            alt="Podcast Creation"
            src={`${IMG_PREFIX}about-anchor-polaroids.png`}
            withRetina
            width={550}
            height={692}
            layout="fixed"
          />
        </div>
        <div className={styles.smallPolaroidTop}>
          <Img
            isAmp={isAmp}
            alt="Podcast Creation"
            src={`${IMG_PREFIX}about-polaroids-top.png`}
            withRetina
            width={383}
            height={233}
            layout="fixed"
          />
        </div>
        <Row bsClass={`${styles.aboutRow} row`}>
          <Col xs={12} sm={7}>
            <h2>Our history</h2>
            <p>
              We’ve both always loved radio, podcasts, playing music, and all
              things audio. In 2014, we were inspired to build an Anchor
              prototype after realizing how difficult it was to create and
              distribute audio. Our experiment quickly took on a life of its
              own, and we launched the first public version of Anchor in 2016.
              We’re now a growing team, based in NYC and continuing to invent
              crazy new ways for people to immerse themselves in the world of
              audio. We all agree it’s the most fun job we’ve ever had.
              <br />- Mike & Nir, Anchor co-founders
            </p>
            <small className={styles.investors}>
              Anchor’s investors include Accel, Acequia Capital, Mick Batyske,
              Scott Belsky, Betaworks, The Chernin Group, CrunchFund, Eniac
              Ventures, Nir Eyal, GV, Homebrew, Craig Kallman, Avi Muchnick,
              Omidyar Network, SV Angel, Questlove, Vijay Vachani, and some our
              closest friends and family members. We wouldn’t be here without
              their support. 🙏
            </small>
          </Col>
        </Row>
        <div className={styles.smallPolaroidBottom}>
          <Img
            isAmp={isAmp}
            alt="Podcast Creation"
            src={`${IMG_PREFIX}about-polaroids-bottom.png`}
            withRetina
            width={398}
            height={246}
            layout="fixed"
          />
        </div>
      </AMPPageSection>
      <AMPPageSection
        color="black"
        id="team"
        forceAlign={false}
        className={styles.teamSection}
      >
        <h2 className={styles.teamTitle}>The Anchor Team</h2>
        <Row bsClass={`${styles.employeeRow} row`}>
          {EMPLOYEE_DATA.map((employee, index) => (
            <Col xs={12} sm={6} md={4} key={index}>
              <div className={styles.employeeInfo}>
                <Img
                  isAmp={isAmp}
                  alt={employee.name}
                  src={employee.imageUrl}
                  withRetina={!!employee.withRetina}
                  width={110}
                  height={110}
                  layout="fixed"
                />
                <div className={styles.rightContent}>
                  <h3>{employee.name}</h3>
                  <p className={styles.roleDescription}>{employee.role}</p>
                  <p>{employee.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </AMPPageSection>
      <AMPPageSection
        color="black"
        id="join"
        forceAlign={false}
        className={styles.joinSection}
      >
        <p className={styles.joinLine}>
          Don’t see yourself represented here? We’d love to hear from you. Our
          mission is to democratize audio, and we can’t build something that
          works for everyone if we don’t have a team that represents everyone.{' '}
          <a className="cyanLink" href="/jobs">
            Check out our open jobs >
          </a>
        </p>
      </AMPPageSection>
      <AMPPageSection id="contact">
        <Row>
          <Col xs={12} sm={7}>
            <h2>Contact Anchor</h2>
            <p>
              Want to work with us? Get in touch at{' '}
              <a href="mailto:hello@anchor.fm">hello@anchor.fm</a>
            </p>
            <p>
              Got a question about Anchor? Visit us at{' '}
              <a href="https://help.anchor.fm">help.anchor.fm</a>
            </p>
            <p>
              Writing a story?{' '}
              <OutboundLink
                newWindow
                to="https://www.dropbox.com/sh/s1jephnyq9l98hi/AACQZWmeP2no7CbBCivLX6Loa?dl=0"
              >
                Download our press kit
              </OutboundLink>{' '}
              or email us at{' '}
              <a href="mailto:press@anchor.fm">press@anchor.fm</a>
            </p>
          </Col>
        </Row>
      </AMPPageSection>
      <AMPPodcastReadySection />
    </AMPPage>
  );
};

export { AMPAboutPage as default, METADATA };
